/*
 * Superfly Distilling — stable Big Thirst storefront loader
 *
 * Upload this file once to Shopify Content > Files. Future revisions belong
 * behind the versioned config URL below so Superfly's developer never needs to
 * replace the installed script tag for a styling or cart-engine update.
 */
(function () {
  'use strict';

  if (window.__BT_SUPERFLY_LOADER_LOADED) return;
  window.__BT_SUPERFLY_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://checkout-7.bigthirst.com/cdn/shop/files/superfly-storefront-config.js';
  var configSrc = window.__BT_SUPERFLY_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_SUPERFLY_CONFIG_VERSION_OVERRIDE || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-superfly-config', 'true');
  head.appendChild(script);
})();
